import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import MachineSheetRectangle from 'components/layout_and_quote_builder/MachineSheetRectangle.jsx';

// One machine box inside a Manufacturing Line card: a role header (PRINTING / DIE CUTTING), the machine
// name and its type, and its bed drawn to scale (MachineSheetRectangle) with the height X width shorthand
// below it (vertical side first, matching the standard boards -- e.g. "560mm X 770mm"). Shared by
// ManufacturingLineCard (a single line) and the Manufacturing Line List card (its printing / die-cutting
// columns), so the boxes look identical in both.
// style is merged onto the box (e.g. flex: '0 0 auto' when the box is stacked in a column rather than sharing
// a row), so the same box works both side by side and stacked.
const MachineColumn = ({ label, machineName, machineTypeLabel, widthMm, heightMm, kind, maxMachineDimensionMm, style }) => {
  const toDisplay = (valueMm) => (
    window.user_unit == 'in'
      ? `${(parseFloat(valueMm) / 25.4).toFixed(2)}in`
      : `${Math.round(parseFloat(valueMm))}mm`
  );

  return (
    <div className={styles.layout_column} style={{
      display: 'flex', flexDirection: 'column',
      padding: '14px 10px', borderRadius: '10px', background: '#fff',
      border: '1px solid #ececec', boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
      ...(style || {})
    }}>
      <div className={styles.layout_column_label} style={{ color: '#222' }}>{label}</div>
      {/* Machine name is the hero of the box — the largest, darkest text. */}
      <div style={{ fontSize: '13px', fontWeight: 600, color: '#222', lineHeight: 1.3, marginTop: '2px' }}>{machineName}</div>
      {/* The machine's type ("Digital cutting", "Offset", ...) so the user knows WHAT they are selecting —
          for example only digital cutters run the whole-sheet L-shape solutions. */}
      {machineTypeLabel ? (
        <div style={{ fontSize: '12px', fontWeight: 400, color: '#888', lineHeight: 1.3, marginTop: '2px' }}>{machineTypeLabel}</div>
      ) : null}

      <div style={{ marginTop: 'auto' }}>
        <MachineSheetRectangle widthMm={widthMm} heightMm={heightMm} kind={kind} maxMm={maxMachineDimensionMm} />
        {/* Redundant with the bed's own edge labels, so it's the quietest line — small and gray. */}
        {widthMm && heightMm ? (
          <div style={{ fontSize: '12px', fontWeight: 400, color: '#888', marginTop: '2px' }}>{toDisplay(heightMm)} X {toDisplay(widthMm)}</div>
        ) : null}
      </div>
    </div>
  );
};

export default MachineColumn;
